<div class="grid min-h-[140px] w-full place-items-center overflow-x-scroll rounded-lg p-6 lg:overflow-visible">

  <div class="flex flex-col gap-8 text-left">
    <h1 class="block font-sans text-5xl font-semibold leading-tight tracking-normal text-blue-gray-900 antialiased">Sample Title</h1>
    
    <!-- <h1 class="block font-sans text-5xl font-semibold leading-tight tracking-normal text-blue-500 antialiased">Material Tailwind</h1><h1 class="block font-sans text-5xl font-semibold leading-tight tracking-normal text-red-500 antialiased">Material Tailwind</h1><h1 class="block font-sans text-5xl font-semibold leading-tight tracking-normal text-green-500 antialiased">Material Tailwind</h1></div><div class="w-full md:w-7/12 pt-5 px-4 mb-8 mx-auto text-center"> -->



  <p class="block font-sans text-base font-light leading-relaxed text-inherit antialiased">
    Material Tailwind is an easy to use components library for Tailwind CSS and Material Design. It provides a simple way to customize your components, you can change the colors, fonts, breakpoints and everything you need.
  </p>
    
    

</div>





<div class="publications">
    <h3 class="content-title">Publications</h3>
    
    <h4>Books</h4>
    
    <ul>
      <li>
        Zucker, R. D. and Biblarz, O., Fundamentals of Gas Dynamics, 3rd Edition, John Wiley & Sons, Inc., 2020.
      </li>
      <li>
        Sutton, G. P. and Biblarz, O., Rocket Propulsion Elements, 9th Edition, Copyright 2017, John Wiley & Sons, Hoboken, NJ.
      </li>
    </ul>
    
    <h4>Patents</h4>
    
    <ul>
      <li>14 patents granted (list available upon request).</li>
    </ul>
    
    <h4>
      Aerodynamics
      </h4>
      <ul>
      <!-- <li class="py-1">
      Biblarz, O., Pomerantz, B. and Lindsey, G.H., "Transonic Missile Drag Area-Rule and Afterbody Role Verification with CFD," Paper AIAA 98-0527, 36th Aerospace Sciences Meeting, Reno, NV, January 12-15, 1998.
      </li> -->
      <li class="py-1">
        Biblarz, O., Pomerantz, B. and Lindsey, G.H., "Transonic Missile Drag Area-Rule and Afterbody Role Verification with CFD," Paper AIAA 98-0527, 36th Aerospace Sciences Meeting, Reno, NV, January 12-15, 1998.
      </li>
      <li class="py-1">
        Biblarz, O., "Things Your BAB (Basic Aerodynamics Book) Never Told You", Paper AIAA 94-0849, 32th Aerospace Sciences Meeting, Reno, NV, January 10-13, 1994.
      </li >
      <li class="py-1">
        Biblarz, O., "Phase Plane Analysis of Transonic Flows", AIAA Paper 76-332, July 1976.
  
      </li>
  
  
      </ul>
  
  
      <h4>Lasers</h4>
      <ul class="px-5">
        <li class="py-1">
          "Laser Internal Aerodynamics and Beam Quality," (with A. E. Fuhs), SPIE Dev. Laser Tech. II, Vol 41, pg 59, 1973.
        </li>
        <li class="py-1">
          "Experimental Verification of Density Inhomogeneity Due to Lasing," (with A. E. Fuhs and others), Appl. Phys. Lett., Vol 24, pg 132, Feb. 1974.
        </li>
        <li class="py-1">
          "Laser Cavity Density Changes with Kinetics of Energy Release," (with A. E. Fuhs) AIAA Journal, Vol 12, pg 1083, 1974.
        </li>
        <li class="py-1">
          "Turbulence Effects on an Ambient Pressure Discharge," (with R. E. Nelson), Journ. Appl. Phys., Vol 45 pg 633, 1974.
        </li>
        <li class="py-1">
          "Gas Dynamic Effects on Diffuse Electrical Discharges in Air," (with J. L. Barto and H. A. Post), The Israel Journal of Technology, Vol 15, pg 59, 1977.
        </li>
        <li class="py-1">
          "Influence of Turbulence on a Diffuse Electrical Gas Discharge Under Moderate Pressures," (with Y. Khait), Journ. Appl. Phys., Vol 50, pg 4692.
        </li>
        <li class="py-1">
          "Fluid-Dynamic Effects, Including Turbulence, on a High- Pressure Discharge," (with J. L. Barto), Gas Flow and Chemical Lasers, 6th Int. Symp. (S. Rosenwaks, Ed.), pg 34, Springer-Verlag, Berlin (1987).
        </li>
        <li class="py-1">
          "On the Thermodynamics of Upconversion and Fluorescence of Light," J. Appl. Phys., Vol 66(12), 15 Dec. 1989, pp. 5685-5690.
        </li>
      </ul>
    
      <h4>Direct Energy Conversion - MHD and EHD</h4>
      <ul class="px-5">
        <li class="py-1">
          "Discharge Characteristics in a Seeded Plasma Flow," (with R. H. Eustis), Electricity from MHD, Vol 1, pg 307. Warsaw, Poland, 1968.
        </li>
        <li class="py-1">
          "The Floating Potential of Emitting Plasma Probes," (with H Derfler) Journal of the Physical Society of Japan, Vol 29, pg 180, 1970.
        </li>
        <li class="py-1"> 
          "Analysis of Optimum Charge Particle Size Based on the Conversion Efficiency of Electrogasdynamic Generators", Energy Conversion, Vol 10, pg 207, 1970.
        </li>
        <li class="py-1">
          "Charge Depletion Mechanism Operative in Space Charge Flows", (with C. Bohley), Journ. Appl. Phys., Vol 44, pg 3055, 1973.
        </li>
        <li class="py-1">
          "Anode Phenomena in a Collision Dominated Plasma," (with R. C. Dolson and A. M. Shorb), Journ. Appl. Phys., Vol 46, pg 3342, 1974.
        </li>
        <li class="py-1">
          "Analysis of the Voltage Drop Arising from a Collision Dominated Sheath," (with R. C. Dolson) Journ. Appl. Phys., Vol 47, pg 5280, 1976.
        </li>
        <li class="py-1">
          "A Simplified Technique for Determining the Boundary Layer Voltage Loss in MHD Generators," (with R. C. Dolson) Energy Conversion, Vol 16, pg 20, 1977.
        </li>
        <li class="py-1">
          "Electrogasdynamic Spectral Anemometer," Journal of Electrostatics, Vol 5, pp. 101-120, 1978.
        </li>
      </ul>
    
      <h4>Plasma Anode Phenomena</h4>
      <ul class="px-5">
        <li class="py-1">
          "Approximate Sheath Solutions for a Planar Plasma Anode," IEEE Trans. Plasma Sci., Vol 19, Dec. 1991, pp. 1235-1243.
        </li>
        <li class="py-1">
          "Plasma-Sheath Approximate Solutions for Planar and Cylindrical Anodes and Probes", (with G. S. Brown), J. Appl. Phys. 73(12), 15 June 1993, pp. 8111.
      </li>
    <li class="py-1">
    O. Biblarz, R. E. Ball, and S. T. Van Brocklin, "Electrode Boundary Layers in Dense, Diffuse Plasmas", AFWAL-TR-80-2088, October 1980.
    </li>
    <li class="py-1">
    O. Biblarz, "Plasma Constriction at the Electrodes Arising from Continuity Considerations", Unpublished.
    </li>
    <li class="py-1">
    O. Biblarz, "Demystifying the Lorenz Equations", Unpublished.
    </li>
    <li class="py-1"><b>Thesis Supervised:</b></li>
    <ul class="px-5">
    <li class="py-1">
    B. Horner, "Anode Fall as Relevant to Plasma Thrusters", Astronautical Engineer's Thesis, Naval Postgraduate School, Monterey CA, June 1997.
    </li>
    </ul>
    </ul>
    
    <h4>
    Propulsion, Space (rockets) and Air-Breathing (gas turbines)
    </h4>
    <ul class="px-5">
    <li class="py-1">
    "Thermionic Arc Breakdown in Small Discharge Gaps: Model and Applications", (with W. J. Bell), IEEE Trans. on Industry Applications, Vol 34, March/April 1998, pp. 325-331.
    </li>
    <li class="py-1"> 
    "Electrostatic Spray Modification in Gas Turbine Combustion", (with J. A. Miller and others), AIAA J. of Propulsion and Power, Vol 3, pg 187, 1987.
    </li>
    <li class="py-1">
    "Study of DC Ion Thrusters with Argon Propellants", (with J. O. Sinibaldi), AIAA 2006-4670, Joint Propulsion Conference, Sacramento, CA, July 2006.
    </li>
    <li class="py-1">
    "Ion Accelerator Currents Beyond Child-Langmuir Limit", AIAA 2013-4109, Joint Propulsion Conference, San Jose, CA, July 2013
    </li>
    </ul>
    
    <h4>
    Surface Plasmons - Ultrafine Surface Particles (Bound Clusters)
    </h4>
    
    <ul>
    <li>
    "Modification to Thermal Emissions by Clusters on Their Own Metallic Surface," J. Vac. Sci. Technol. A, Vol 8(1), Jan/Feb 1990, pp. 127-133.
    </li>
    <li>
    <b>Theses supervised:</b>
    </li>
    <ul>
    <li class="py-1">
    C. W. Baldwin, "Cluster Model of Polarization Upon Reflection from Metallic Surfaces", Master Thesis, Naval Postgraduate School, Monterey, CA, Dec. 1991.
    </li>
    <li class="py-1">
    D. T. Moroney, "Use of an Optical Multichamel Analyzer (OMA) for Reflectivity Measurements", Master Thesis, Naval Postgraduate School, Monterey, CA, Dec. 1993.
    </li>
    </ul>
    </ul>
    <h4>
    Measurement Apparatus
    </h4>
    <ul>
    <li class="py-1">
    O. Biblarz, "Determination of Soot Concentration in Plumes from Optical Transmission Measurements", Unpublished.
    </li>
    <li class="py-1">
    "Electrogasdynamic Spectral Anemometer," Journal of Electrostatics, Vol 5, pp. 101-120, 1978.
    </li>
    </ul>
    

  
  </div>